import createAuth from './auth'
import createAdmin from './admin'
import createOutputs from './outputs'
import createTemplates from './templates'
import createSources from './sources'
import createEntities from './entities'
import createDictionaries from './dictionaries'
import createImports from './imports'
import createViews from './views'
import createUsers from './users'
import createPresets from './presets'
import createSnapshots from './snapshots'
import createAudit from './audit'

const create = api => ({
    auth: createAuth(api),
    admin: createAdmin(api),
    outputs: createOutputs(api),
    templates: createTemplates(api),
    sources: createSources(api),
    entities: createEntities(api),
    imports: createImports(api),
    views: createViews(api),
    dictionaries: createDictionaries(api),
    users: createUsers(api),
    presets: createPresets(api),
    snapshots: createSnapshots(api),
    audit: createAudit(api),
})

export default {
    create,
}
